import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'durationFormat',
  standalone: true,
})
export class DurationFormatPipe implements PipeTransform {
  private transloco = inject(TranslocoService);

  transform(duration: number | null | undefined): string {
    if (duration == null) return '-';

    const hours = Math.floor(duration);
    const minutes = Math.round((duration % 1) * 60);

    const hrs = hours.toString().padStart(2, '0');
    const mins = minutes.toString().padStart(2, '0');

    const h = this.transloco.translate('duration.hourSeparator');
    const m = this.transloco.translate('duration.minutes');

    return hours > 0 ? `${hrs}${h}${mins}` : `${mins} ${m}`;
  }
}
